<div class="user-activate-popup">
<h1 mat-dialog-title *ngIf="model?.title">{{model?.title}}</h1>
<div mat-dialog-content class="mat-typography text-center">
    {{model?.content}}
</div>
<div mat-dialog-actions class="text-center justify-content-center">
    <button mat-flat-button color="primary" (click)="dialogRef.close()">
        {{model?.closeButtonText}}
    </button>
</div>
</div>
